module.exports = __webpack_public_path__ + "img/collaborate_32.d630198d.jpg";